export default {
  Accept: require('./accept').default,
  Header: require('./header').default,
  ModifyBooking: require('./modify_booking').default,
  Review: require('./review').default,
  Gone: require('./gone').default,
  UI: {
    Modal: require('views/shared/ui/modal').default,
  },
};
